import { render, staticRenderFns } from "./modalAlteracaoAgenda.vue?vue&type=template&id=43ab2106&"
import script from "./modalAlteracaoAgenda.vue?vue&type=script&lang=js&"
export * from "./modalAlteracaoAgenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports